import axios from 'axios';

export default axios.create({
    baseURL: 'https://accessrequest.taboola.com'
    // Need to do some work in order for it to work from the service
});